import { isNative } from 'src/utils/platform';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { reportError } from 'src/modules/logs/Sentry';

type AppIconPlugin = {
  getName(): Promise<{ value: string | null }>;
  reset(options: {
    suppressNotification?: boolean;
    disable?: string[];
  }): Promise<void>;
};

const ANDROID_SEASONAL_ALIASES = ['christmas', 'halloween', 'carnaval'];

// Old shells (<= 1607) ship @capacitor-community/app-icon and old bundles
// switched the launcher icon by calendar. A device left on a seasonal icon (on
// Android with .MainActivity disabled) would stay there now that nothing
// switches it back. Remove with the splash compatibility branch.
export const resetLegacyAppIcon = async (): Promise<void> => {
  if (
    !isNative() ||
    !Capacitor.isPluginAvailable('AppIcon')
  ) {
    return;
  }
  try {
    const AppIcon = registerPlugin<AppIconPlugin>('AppIcon');
    const { value } = await AppIcon.getName();
    if (value === null || value === 'Default') return;
    await AppIcon.reset({
      suppressNotification: true,
      disable: ANDROID_SEASONAL_ALIASES,
    });
  } catch (error) {
    reportError('Failed to reset the legacy seasonal app icon', error);
  }
};
